import axios from "axios";
import moment from 'moment';


// export const API_ENDPOINT = "http://139.59.62.38:3031/";
// export const API_ENDPOINT = "http://localhost:3031/"
 export const API_ENDPOINT = "https://api.capexcourier.com/"


 export const SOCKET_SERVER_URL = 'https://api.capexcourier.com/';
// export const SOCKET_SERVER_URL = 'http://139.59.62.38:3005';
// export const SOCKET_SERVER_URL = 'http://localhost:3005';

var cancelToken;

export const getAxiosInstance = () => {
  var axiosInstance = axios.create({
    timeout: 1000 * 60
    // headers: {
    // 	'Content-Type': 'application/json',
    // 	'Accept': '*/*',
    // }
  });
  axiosInstance.defaults.baseURL = API_ENDPOINT;
  return axiosInstance;
};

var axiosInstance = getAxiosInstance();
axiosInstance.interceptors.request.use(
  function (config) {
    console.log(config.url);
    if (config.url === "auth/local") {
      return config;
    } else {
      let authToken = window.localStorage.getItem("jwt");
      console.log(`auth ${authToken}`);
      config.headers["Authorization"] = `Bearer ${authToken}`;
    }
    return config;
  },
  function (error) {
    console.log(error);
    return Promise.reject(error);
  }
);

export const fetchLogin = (username, password) => {
  return axiosInstance.post(
    "users/login",
    {
      username: username,
      password: password,
    },
    {}
  );
};

export const getPackages = (param) => {
  return axiosInstance.get(`/parcel${param ? `?${param}` : ``}`);
}

export const getBranches = (param) => {
  return axiosInstance.get(`/branches${param ? `?${param}` : ``}`);
}

export const getCorporateClients = () => {
  return axiosInstance.get(`/corporate_clients`);
}

export const getPaymentModes = (param) => {
  return axiosInstance.get(`/payment_mode${param ? `?${param}` : ``}`);
}

export const addPaymentMode = (details) => {
  return axiosInstance.post(`/payment_mode`, details);
}

export const updatePaymentMode = (id, details) => {
  return axiosInstance.put(`/payment_mode/${id}`, details);
}

export const getReceivingAccounts = (param) => {
  return axiosInstance.get(`/receiving_account${param ? `?${param}` : ``}`);
}

export const getEmployees = (param) => {
  return axiosInstance.get(`/employees${param ? `?${param}` : ``}`);
}

export const addEmployee = (details) => {
  return axiosInstance.post(`/employees`, details);
}

export const updateEmployee = (id, details) => {
  return axiosInstance.put(`/employees/${id}`, details);
}

export const addReceivingAccount = (details) => {
  return axiosInstance.post(`/receiving_account`, details);
}

export const updateReceivingAccount = (id, details) => {
  return axiosInstance.put(`/receiving_account/${id}`, details);
}

export const addCorporateClient = (details) => {
  return axiosInstance.post(`/corporate_clients`, details);
}

export const getCourierMode = () => {
  return axiosInstance.get(`/carriers`);
}

export const addCarrier = (details) => {
  return axiosInstance.post(`/carriers`, details);
}

export const getPackageType = () => {
  return axiosInstance.get(`/package_type`);
}

export const getBox = (id) => {
  return axiosInstance.get(`/boxes?id=${id}`);
}

export const getBoxes = (param) => {
  return axiosInstance.get(`/boxes${param ? `?${param}` : ``}`);
}

export const getProducts = (param) => {
  return axiosInstance.get(`/products${param ? `?${param}` : ``}`);
}

// Connected vendor APIs (BE src/vendors/vendorApis.js). Passwords are write-only.
export const getVendorApis = () => {
  return axiosInstance.get(`/vendor_apis`);
}

export const addVendorApi = (details) => {
  return axiosInstance.post(`/vendor_apis`, details);
}

export const updateVendorApi = (key, details) => {
  return axiosInstance.put(`/vendor_apis/${key}`, details);
}

export const resetVendorApi = (key) => {
  return axiosInstance.delete(`/vendor_apis/${key}`);
}

export const testVendorApi = (key) => {
  return axiosInstance.post(`/vendor_apis/${key}/test`, {});
}

// Activity log (BE src/activity/activityLog.js)
export const getActivityFeed = (params = {}) => {
  const q = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== "")
    .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
    .join("&");
  return axiosInstance.get(`/activity_logs/feed${q ? `?${q}` : ""}`);
}

export const getActivityUsers = () => {
  return axiosInstance.get(`/activity_logs/users`);
}

// Box item-name master (sorted, searchable, paged — see BE src/masters/products.js)
export const getItemMaster = ({ search = "", page = 1, limit = 25 } = {}) => {
  return axiosInstance.get(`/products/master?search=${encodeURIComponent(search)}&page=${page}&limit=${limit}`);
}

export const addItemMaster = (details) => {
  return axiosInstance.post(`/products/master`, details);
}

export const updateItemMaster = (id, details) => {
  return axiosInstance.put(`/products/master/${id}`, details);
}

export const deleteItemMaster = (id) => {
  return axiosInstance.delete(`/products/master/${id}`);
}

// Bulk delete: { ids } or { all_matching: true, search }
export const bulkDeleteItemMaster = (details) => {
  return axiosInstance.post(`/products/master/bulk-delete`, details);
}

// Blank Excel upload template for Item Names
export const downloadItemTemplate = () => {
  return axiosInstance.get(`/products/master/template`, { responseType: "blob" });
}

// Bulk upload parsed sheet rows. mode: "skip" | "update" (existing names)
export const importItemMaster = (rows, mode) => {
  return axiosInstance.post(`/products/master/import`, { rows, mode });
}

export const getManufacturers = (param) => {
  return axiosInstance.get(`/manufacturers${param ? `?${param}` : ``}`);
}

export const getDashboardData = (param) => {
  return axiosInstance.get(`/parcel/status${param ? `?${param}` : ``}`);
}

export const getCarrierStats = (param) => {
  return axiosInstance.get(`/parcel/carrier_stats${param ? `?${param}` : ``}`);
}

export const getStatusBreakdown = (param) => {
  return axiosInstance.get(`/parcel/status_breakdown${param ? `?${param}` : ``}`);
}

export const getContacts = (param) => {
  return axiosInstance.get(`/clients${param ? `?${param}` : ``}`);
}

export const getCarriers = (param) => {
  return axiosInstance.get(`/carriers${param ? `?${param}` : ``}`);
}

export const getCountries = (param) => {
  return axiosInstance.get(`/countries${param ? `?${param}` : ``}`);
}

// ZIP / postcode -> state + town for US / CA / AU receivers (see BE src/postal/postalLookup.js)
export const lookupPostal = (country, code) => {
  return axiosInstance.get(`/countries/postal?country=${encodeURIComponent(country)}&code=${encodeURIComponent(code)}`);
}

export const addCountriy = (details) => {
  return axiosInstance.post(`/countries`, details);
}

export const createUpdatePackage = (body) => {
  return axiosInstance.post(`/parcel/handle`, body, {});
}

export const getVendorCatalog = () => {
  return axiosInstance.get(`/parcel/vendorcatalog`);
}

// Attach a waybill that already exists at the vendor (never creates one).
export const linkVendorWaybill = (details) => {
  return axiosInstance.post(`/parcel/vendorlink`, details, { timeout: 1000 * 60 * 3 });
}

export const bookWithVendor = (details) => {
  // The vendor can take well over a minute (booking + labels, plus a recovery
  // check if it's slow) — don't give up before the server does.
  return axiosInstance.post(`/parcel/vendorbook`, details, { timeout: 1000 * 60 * 4 });
}

export const voidVendorBooking = (details) => {
  return axiosInstance.post(`/parcel/vendorvoid`, details, {});
}

// Mark In Transit with the vendor's carrier number — does NOT message the customer.
export const markVendorTransit = (details) => {
  return axiosInstance.post(`/parcel/vendortransit`, details, {});
}

// Send the tracking number to the customer (WhatsApp, SMS fallback). { id, force? }
export const sendVendorTracking = (details) => {
  return axiosInstance.post(`/parcel/vendornotify`, details, {});
}

export const refreshVendorLabel = (details) => {
  return axiosInstance.post(`/parcel/vendorlabel`, details, {});
}

// ── Internal tracking (white-label) ──────────────────────────────────────
export const getInternalBoard = (includeDelivered) => {
  return axiosInstance.get(`/parcel/internal-tracking/board${includeDelivered ? `?include_delivered=1` : ``}`);
}

export const setInternalVendor = (details) => {
  return axiosInstance.post(`/parcel/internal-tracking/set-vendor`, details, {});
}

export const setInternalFields = (details) => {
  return axiosInstance.post(`/parcel/internal-tracking/set-fields`, details, {});
}

export const refreshAllInternal = () => {
  return axiosInstance.post(`/parcel/internal-tracking/refresh-all`, {}, {});
}

export const refreshInternal = (details) => {
  return axiosInstance.post(`/parcel/internal-tracking/refresh`, details, {});
}

export const approveInternal = (details) => {
  return axiosInstance.post(`/parcel/internal-tracking/approve`, details, {});
}

export const rejectInternal = (details) => {
  return axiosInstance.post(`/parcel/internal-tracking/reject`, details, {});
}

export const syncAwbsInternal = () => {
  return axiosInstance.post(`/parcel/internal-tracking/sync-awbs`, {}, {});
}

export const setInternalAwb = (details) => {
  return axiosInstance.post(`/parcel/internal-tracking/set-awb`, details, {});
}

export const getInternalStats = () => {
  return axiosInstance.get(`/parcel/internal-tracking/stats`);
}

export const getInternalDetail = (id) => {
  return axiosInstance.get(`/parcel/internal-tracking/detail?id=${id}`);
}

export const manualInternalUpdate = (details) => {
  return axiosInstance.post(`/parcel/internal-tracking/update`, details, {});
}

export const setInternalBoxWeight = (details) => {
  return axiosInstance.post(`/parcel/internal-tracking/set-box-weight`, details, {});
}

// Internal-tracking vendors (SDK CRUD on tracking_vendors).
export const getTrackingVendors = () => {
  return axiosInstance.get(`/tracking_vendors`);
}

export const addTrackingVendor = (details) => {
  return axiosInstance.post(`/tracking_vendors`, details);
}

export const updateTrackingVendor = (id, details) => {
  return axiosInstance.put(`/tracking_vendors/${id}`, details);
}

// Learning queue: phrases staff used that the engine doesn't know yet.
export const getPhraseQueue = () => {
  return axiosInstance.get(`/parcel/internal-tracking/phrase-queue`);
}

export const resolvePhraseQueue = (details) => {
  return axiosInstance.post(`/parcel/internal-tracking/phrase-queue/resolve`, details, {});
}

// Editable internal-tracking stage phrases (SDK CRUD on tracking_stages).
export const getTrackingStages = () => {
  return axiosInstance.get(`/tracking_stages`);
}

export const addTrackingStage = (details) => {
  return axiosInstance.post(`/tracking_stages`, details);
}

export const updateTrackingStage = (id, details) => {
  return axiosInstance.put(`/tracking_stages/${id}`, details);
}

export const deleteTrackingStage = (id) => {
  return axiosInstance.delete(`/tracking_stages/${id}`);
}

export const updatePackageStatus = (id, data) => {
  return axiosInstance.put(`/parcel/${id}`, data, {});
}

export const getDeclarations = () => {
  return axiosInstance.get(`/declarations`);
}

export const addDeclaration = (details) => {
  return axiosInstance.post(`/declarations`, details);
}

export const updateDeclaration = (id, details) => {
  return axiosInstance.put(`/declarations/${id}`, details);
}

export const getTrackingMessages = (param) => {
  return axiosInstance.get(`/tracking_messages${param ? `?${param}` : ``}`);
}

export const addTrackingMessage = (details) => {
  return axiosInstance.post(`/tracking_messages`, details);
}

export const updateTrackingMessage = (id, details) => {
  return axiosInstance.put(`/tracking_messages/${id}`, details);
}

export const generateShippingInv = (body) => {
  return axiosInstance.post(`/parcel/invoice/items`, body, {});
}

export const generateAddressDocument = (body) => {
  return axiosInstance.post(`/parcel/invoice/doc`, body, {});
}

export const uploadFile = (data) => {
  return axiosInstance.post(`/upload`, data, {});
}

export const generateBillingInvoice = (body) => {
  return axiosInstance.post(`/parcel/bill/cash`, body, {});
}

export const updateTrackingStatus = (id, data) => {
  return axiosInstance.put(`/package_history/${id}`, data);
}

export const deleteTrackingHistory = (id) => {
  return axiosInstance.delete(`/package_history/${id}`);
}

export const getPackageHistory = (id) => {
  return axiosInstance.get(`/package_history?package=${id}`);
}

export const deletePackage = (id) => {
  return axiosInstance.delete(`/parcel/${id}`);
}

export const getSmsHistory = (param) => {
  return axiosInstance.get(`/sms_history${param ? `?${param}` : ``}`);
}

export const sendSMS = (details) => {
  return axiosInstance.post(`/parcel/sendsms`, details);
}

export const getUsers = (param) => {
  return axiosInstance.get(`/users${param ? `?${param}` : ``}`);
}

export const addBranch = (details) => {
  return axiosInstance.post(`/branches`, details);
}

export const getUserRoles = (param) => {
  return axiosInstance.get(`/user_roles${param ? `?${param}` : ``}`);
}

export const addUser = (details) => {
  return axiosInstance.post(`/users`, details);
}

export const updateBranchDetails = (id, details) => {
  return axiosInstance.put(`branches/${id}`, details);
}

export const getWhatsappContacts = () => {
  return axiosInstance.get(`clients/getcontacts`);
}

export const getWhatsappChatToken = () => {
  return axiosInstance.get(`clients/chattoken`);
}

export const getWhatsappTemplates = (param) => {
  return axiosInstance.get(`/whatsapp_templates${param ? `?${param}` : ``}`);
}

export const addWhatsappTemplate = (details) => {
  return axiosInstance.post(`/whatsapp_templates`, details);
}

export const getWhatsappTemplateHistory = (param) => {
  return axiosInstance.get(`/whatsapp_template_history${param ? `?${param}` : ``}`);
}

export const addWhatsappCampaign = (details) => {
  return axiosInstance.post(`/whatsapp_templates/bulksend`, details);
}


export const getCustomerListFile = (param) => {
  return axiosInstance.get(`clients/export${param ? `?${param}` : ``}`, {
    responseType: 'blob'
  });
}

export const updateWhatsappTemplate = (id, details) => {
  return axiosInstance.put(`/whatsapp_templates/${id}`, details);
}

export const getPricingTemplates = (param) => {
  return axiosInstance.get(`/pricing_templates${param ? `?${param}` : ``}`);
}

export const addPricingTemplate = (details) => {
  return axiosInstance.post(`/pricing_templates`, details);
}

export const getPricingGroups = (param) => {
  return axiosInstance.get(`/pricing_group${param ? `?${param}` : ``}`);
}

export const addPricingGroup = (details) => {
  return axiosInstance.post(`/pricing_group`, details);
}

export const getPriceList = (param) => {
  return axiosInstance.get(`/pricings${param ? `?${param}` : ``}`);
}
export const addPriceList = (details) => {
  return axiosInstance.post(`/pricings`, details);
}
export const updatePriceList = (id, details) => {
  return axiosInstance.put(`/pricings/${id}`, details);
}

export const fetchModes = (param) => {
  return axiosInstance.get(`/pricing_mode${param ? `?${param}` : ``}`);
}
export const addPriceMode = (details) => {
  return axiosInstance.post(`/pricing_mode`, details);
}
export const calculatePricing = (details) => {
  return axiosInstance.post(`/pricings/calculator`, details);
}

export const getParcelBoxes = (parcelId) => {
  return axiosInstance.get(`/parcel/boxes/${parcelId}`);
}

export const updateBoxStatus = (data) => {
  return axiosInstance.post(`/parcel/box/status`, data, {});
}

/* ── Demand forecasting ─────────────────────────────────────────────────────
   Read-only against shipments. `demand_events` gets its CRUD for free from the
   SDK because the collection is declared in the backend's collections.js. */

export const getForecast = (param) => {
  return axiosInstance.get(`/parcel/forecast${param ? `?${param}` : ``}`);
}

export const getForecastScopes = () => {
  return axiosInstance.get(`/parcel/forecast/scopes`);
}

export const getDemandEvents = (param) => {
  return axiosInstance.get(`/demand_events${param ? `?${param}` : ``}`);
}

export const addDemandEvent = (details) => {
  return axiosInstance.post(`/demand_events`, details);
}

export const updateDemandEvent = (id, details) => {
  return axiosInstance.put(`/demand_events/${id}`, details);
}

export const deleteDemandEvent = (id) => {
  return axiosInstance.delete(`/demand_events/${id}`);
}
